import classNames from 'class-names';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';

import useSmallScreen from '../../../lib/hooks/useSmallScreen';

import Cell from './Cell';
import Others from './Others';
import TabHeader from './TabHeader';
import VSat from './VSat';
import styles from './wan.module.css';
import Accordion from './WanAccordion';
import Wifi from './Wifi';

const connectionTypeComponents = {
  alternate: Others,
  backup: Others,
  vsat: VSat,
  cell: Cell,
  wifi: Wifi,
};

const Wan = ({
  connections,
  activeConnectionName = connections[0]?.name,
  children,
  displayKpi = false,
}) => {
  const isMediumScreen = useSmallScreen('md');
  const [selectedConnectionName, setSelectedConnectionName] =
    useState(activeConnectionName);

  useEffect(() => {
    setSelectedConnectionName(selectedConnectionName);
  }, [activeConnectionName]);

  return isMediumScreen && connections.length > 1 ? (
    <Accordion
      connections={connections}
      activeConnectionName={activeConnectionName}
      displayKpi={displayKpi}
      connectionTypeComponents={connectionTypeComponents}
    >
      {children}
    </Accordion>
  ) : (
    <Tabs
      activeKey={selectedConnectionName}
      onSelect={setSelectedConnectionName}
      className={classNames(
        'nav-tabs-light justify-content-sm-start border-bottom-0 terminal-home',
        {
          'nav-fill mr-3': isMediumScreen && connections.length > 1,
        },
      )}
    >
      {connections.map(({ name, data }) => {
        const TabContentComponent = connectionTypeComponents[name];

        if (!TabContentComponent) return null;

        return (
          <Tab
            eventKey={name}
            key={name}
            title={
              <TabHeader
                activeConnectionName={activeConnectionName}
                connectionName={name}
                connectionStatus={data.connectionStatus}
                kpi={displayKpi ? data.kpi : null}
              />
            }
            tabClassName={styles.navLink}
          >
            <Container fluid className="bg-white py-2">
              <TabContentComponent name={name} {...data}>
                {children}
              </TabContentComponent>
            </Container>
          </Tab>
        );
      })}
    </Tabs>
  );
};

Wan.propTypes = {
  connections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.shape({}).isRequired,
    }).isRequired,
  ).isRequired,
  activeConnectionName: PropTypes.oneOf([
    'vsat',
    'cell',
    'wifi',
    'alternate',
    'backup',
  ]),
  children: PropTypes.node,
  displayKpi: PropTypes.bool,
};

const WanSettingsLink = ({ children }) => children;

WanSettingsLink.propTypes = {
  children: PropTypes.node,
};

Wan.WanSettingsLink = WanSettingsLink;

export default Wan;
